<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="true"
    :okText="this.$store.getters.language['common.okButton']"
    @setInnerFullscreen="setInnerFullscreen"
    :fullscreen="innerFullscreen"
    :cancelText="language['common.closeButton']">
    <my-todo-form ref="realForm" @ok="submitCallback" @close="close" :setEdit="setEdit" v-if="initForm"
                  :disabled="disableSubmit" :innerFullscreen="innerFullscreen"></my-todo-form>
  </j-modal>
</template>

<script>

  import MyTodoForm from './MyTodoForm'

  export default {
    name: 'MyTodoModal',
    components: {
      MyTodoForm
    },
    data() {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        innerFullscreen:true,
        setEdit:false,
        initForm:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      setInnerFullscreen(val) {
        this.innerFullscreen = val
      },
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit(record) {
        this.setEdit = record.setEdit!==null&&record.setEdit!==''&&record.setEdit!==undefined?record.setEdit:false;
        this.innerFullscreen=true;
        this.initForm = true;
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close() {
        this.$emit('reSeach');
        this.visible = false;
      },
      handleOk() {
        this.$refs.realForm.submitForm();
      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .ant-modal-body {
    padding: 8px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
  }

</style>